import { Separator } from "@radix-ui/react-separator";
import { createFileRoute } from "@tanstack/react-router";
import { BaseSidebar } from "@/components/Sidebar/BaseSidebar";
import {
	Map as LeafletMap,
	MapLayers,
	MapMarker,
	MapTileLayer,
} from "@/components/ui/map";
import {
	SidebarInset,
	SidebarProvider,
	SidebarTrigger,
} from "@/components/ui/sidebar";
import { inventoryNavItems } from "@/data/inventory-nav";

export const Route = createFileRoute("/flex/dashboard/v2/inventories")({
	component: RouteComponent,
});

function RouteComponent() {
	return (
		<SidebarProvider>
			<BaseSidebar
				// className="w-64"
				navItems={inventoryNavItems}
				groupLabel="Inventory Management"
			/>
			<SidebarInset className="h-[calc(100svh-4rem)]">
				<div className="flex flex-1 flex-col overflow-hidden">
					<header className="flex h-16 shrink-0 items-center gap-2 border-b">
						<div className="flex items-center gap-2 px-4">
							<SidebarTrigger />
							<Separator
								orientation="vertical"
								className="mr-2 data-[orientation=vertical]:h-4"
							/>
							<h1 className="text-lg font-semibold">Inventory Map</h1>
						</div>
					</header>
					<main className="flex-1 p-4">
						<LeafletMap
							center={[40.369603656472506, -3.7439399153413864]}
							zoom={20}
						>
							<MapLayers defaultTileLayer="OpenStreetMap">
								<MapTileLayer name="OpenStreetMap" source="openstreetmap" />
								{/* <MapLayersControl /> */}
							</MapLayers>
							<MapMarker position={[40.369603656472506, -3.7439399153413864]} />

							{/* <MapZoomControl /> */}
							{/* <MapLocateControl /> */}
						</LeafletMap>
					</main>
				</div>
			</SidebarInset>
		</SidebarProvider>
	);
}
